import React from "react";
import Modal from "../../Reusable/Modal";
import CreateContacts from "../CreateContacts/CreateContacts";
//@ts-ignore
import { tw } from "@careinfo/tailwind"

import { useQueryClient } from "@tanstack/react-query"; 

const CreateContactModal = ({ isOpen, setIsOpen }: { isOpen: boolean; setIsOpen: (val: boolean) => void }) => {
  const queryClient = useQueryClient();

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} title="Create Contact">
      <div className={tw`flex flex-col items-center w-[600px]`}>
        <CreateContacts 
          setIsOpen={setIsOpen} 
          invalidateQuery={() => queryClient.invalidateQueries({ queryKey: ["contacts"] })} 
        />
      </div>
    </Modal>
  );
};

export default CreateContactModal;
